import {makeAutoObservable} from "mobx";

export class OrderStorage {
    ORDER = 'marketplace-order';
    constructor(storage) {
        this._storage = storage;
        this._order = this._storage.get(this.ORDER) || null;
        makeAutoObservable(this);
    }

    removeOrder() {
        this._order = undefined
        this._storage.remove(this.ORDER)
    }

    addOrder(order) {
        this._order = JSON.stringify(order)
        this._storage.add(this.ORDER, this._order);
    }

    getOrder() {
        this._order = this._storage.get(this.ORDER);
        return JSON.parse(this._order)
    }

    hasOrder() {
        const order = this.getOrder();
        return order !== null && order !== undefined;
    }
}
